/* cc-variant-modal — visual variant picker.
   window.ccVariantModal.open(handle) fetches /products/<handle>.js and
   shows big image tiles per variant; select → Add to cart (ccAddToCart).
   One modal instance is created lazily and reused. */

(() => {
  /* init guard — more than one section can load this file on a page;
     duplicate <script src> tags each execute (double delegation = double ATC) */
  if (window.ccInitGuardccVariantModal) return;
  window.ccInitGuardccVariantModal = true;

  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const money = (cents) => '$' + (cents / 100).toFixed(2);
  let root = null;
  let selected = null;
  let lastFocus = null;
  const cache = {};

  function build() {
    root = document.createElement('div');
    root.className = 'cc-vmodal';
    root.hidden = true;
    root.innerHTML = `
      <div class="cc-vmodal__overlay" data-cc-vclose></div>
      <div class="cc-vmodal__panel" role="dialog" aria-modal="true" aria-label="Choose an option">
        <div class="cc-vmodal__head">
          <div>
            <h2 class="cc-vmodal__title"></h2>
            <p class="cc-vmodal__hint">Pick an option</p>
          </div>
          <button type="button" class="cc-vmodal__close" data-cc-vclose aria-label="Close">
            <svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          </button>
        </div>
        <div class="cc-vmodal__grid"></div>
        <div class="cc-vmodal__foot">
          <button type="button" class="cc-btn cc-vmodal__add" disabled>Add to cart</button>
        </div>
      </div>`;
    document.body.appendChild(root);

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-cc-vclose]')) close();
      const tile = e.target.closest('.cc-vmodal__tile:not(.cc-vmodal__tile--soldout)');
      if (tile) select(tile);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !root.hidden) close();
    });
    root.querySelector('.cc-vmodal__add').addEventListener('click', async function () {
      if (!selected) return;
      const ok = await window.ccAddToCart(selected, this);
      if (ok) close();
    });
  }

  function select(tile) {
    root.querySelectorAll('.cc-vmodal__tile').forEach((t) => t.setAttribute('aria-pressed', 'false'));
    tile.setAttribute('aria-pressed', 'true');
    selected = tile.dataset.variantId;
    root.querySelector('.cc-vmodal__add').disabled = false;
  }

  function close() {
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function show() {
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.cc-vmodal__close').focus();
  }

  async function open(handle) {
    if (!root) build();
    lastFocus = document.activeElement;
    selected = null;

    let product = cache[handle];
    if (!product) {
      // open INSTANTLY with a shimmer skeleton — the fetch used to run
      // before anything appeared and the tap felt dead (Tony 2026-07-12)
      root.querySelector('.cc-vmodal__title').innerHTML =
        '<span class="cc-vmodal__skel cc-vmodal__skel--title"></span>';
      root.querySelector('.cc-vmodal__hint').textContent = 'Loading options…';
      root.querySelector('.cc-vmodal__add').disabled = true;
      root.querySelector('.cc-vmodal__grid').innerHTML =
        '<div class="cc-vmodal__tile cc-vmodal__tile--skel" aria-hidden="true"><span class="cc-vmodal__skel cc-vmodal__skel--img"></span><span class="cc-vmodal__skel cc-vmodal__skel--line"></span><span class="cc-vmodal__skel cc-vmodal__skel--line cc-vmodal__skel--short"></span></div>'.repeat(3);
      show();
      try {
        product = await (await fetch(`/products/${handle}.js`)).json();
        cache[handle] = product;
      } catch {
        window.location.href = '/products/' + handle;
        return;
      }
      if (root.hidden) return; // closed while loading — don't repopen
    }

    root.querySelector('.cc-vmodal__title').textContent = product.title;
    root.querySelector('.cc-vmodal__hint').textContent =
      product.options && product.options.length ? 'Pick a ' + product.options.map((o) => (o.name || o).toString().toLowerCase()).join(' / ') : 'Pick an option';
    root.querySelector('.cc-vmodal__add').disabled = true;

    const fallback = product.featured_image || (product.images && product.images[0]) || '';
    root.querySelector('.cc-vmodal__grid').innerHTML = product.variants
      .map((v) => {
        const src = (v.featured_image && v.featured_image.src) || fallback;
        const sized = src ? src + (String(src).includes('?') ? '&' : '?') + 'width=400' : '';
        return `<button type="button" class="cc-vmodal__tile${v.available ? '' : ' cc-vmodal__tile--soldout'}" data-variant-id="${v.id}" aria-pressed="false" ${v.available ? '' : 'disabled'}>
          ${sized ? `<img src="${esc(sized)}" alt="${esc(v.title)}" width="400" height="400" loading="lazy">` : ''}
          <span class="cc-vmodal__tile-name">${esc(v.title)}</span>
          <span class="cc-vmodal__tile-price">${v.available ? money(v.price) : 'Sold out'}</span>
        </button>`;
      })
      .join('');

    show();
  }

  window.ccVariantModal = { open };
})();
